<template>

    <div>
        
        <h2>{{$t('EDIT_PROFILE')}}</h2>
        <hr>
        
        <div v-if="response.success != null" v-bind:class="{ 'alert-success': response.success, 'alert-danger': !response.success }" class="alert" role="alert">
            {{response.message}}
        </div>

        <div id="form">
            <div class="input-group mb-3">
                <div class="col-12">
                    <span id="inputGroup-sizing-lg">{{$t('FIRST_NAME')}}</span>
                </div>
                <div class="col-5">
                    <input v-model="doctorProfile.firstName" type="text"  class="form-control">
                </div>
            </div>
            <div class="input-group mb-3">
                <div class="col-12">
                    <span id="inputGroup-sizing-lg">{{$t('LAST_NAME')}}</span>
                </div>
                <div class="col-5">
                    <input v-model="doctorProfile.lastName" type="text"  class="form-control">
                </div>
            </div>
            <div class="input-group mb-3">
                <div class="col-12">
                    <span id="inputGroup-sizing-lg">{{$t('EMAIL')}}</span>
                </div>
                <div class="col-5">
                    <input v-model="doctorProfile.email" type="email"  class="form-control" readonly='true'>
                </div>
            </div>
            <div class="input-group mb-3">
                <div class="col-12">
                    <span id="inputGroup-sizing-lg">{{$t('RIZIV')}}</span>
                </div>
                <div class="col-5">
                    <input v-model="doctorProfile.riziv" type="text"  class="form-control">
                </div>
            </div>
            <div class="input-group mb-3">
                <div class="col-12">
                    <span id="inputGroup-sizing-lg">{{$t('PHONE')}}</span>
                </div>
                <div class="col-5">
                    <input v-model="doctorProfile.phoneNumber" type="text"  class="form-control">
                </div>
            </div>
            <div class="input-group mb-3">
                <div class="col-12">
                    <span id="inputGroup-sizing-lg">{{$t('CITY')}}</span>
                </div>
                <div class="col-5">
                    <input v-model="doctorProfile.city" type="text"  class="form-control" >
                </div>
            </div>
            <div class="input-group mb-3">
                <div class="col-12">
                    <span id="inputGroup-sizing-lg">{{$t('ADDRESS')}}</span>
                </div>
                <div class="col-5">
                    <input v-model="doctorProfile.address" type="text"  class="form-control">
                </div>
            </div>
            <div class="input-group mb-3">
                <div class="col-12">
                    <span id="inputGroup-sizing-lg">{{$t('POSTCODE')}}</span>
                </div>
                <div class="col-5">
                    <input v-model="doctorProfile.postcode" type="text"  class="form-control">
                </div>
            </div>
            <div class="input-group mb-3">
                <div class="col-12">
                    <span for="inputGroupSelect01">{{$t('LANGUAGE')}}</span>
                </div>
                <div class="col-5">
                    <select @change="onSelect($event.target.value)" class="custom-select" id="inputGroupSelect01">
                        <option v-for="(lang,index) in languages" :key="index"  :selected='lang.title == doctorProfile.language.title' :value="lang.id">
                            {{lang.longTitle}} 
                            
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <div class="col-5">
            <button @click="editDoctorProfile()" type="button" class="mb-3">{{$t('SAVE_CHANGES')}}</button>
        </div>
        
    </div>

</template>
<script>
export default {
    data() {
        return {
            doctorProfile :
            {
                "firstName": "",
                "lastName": "",
                "email": "",
                "riziv": "",
                "phoneNumber": "",
                "city": "",
                "postcode": "",
                "address": "",
                "language": {},
                "languageId": ""
            },
            response: {
                success: null,
                message: ""
            },
            selectedLanguageId: '',
        }
    },
    methods: {
        getDoctorInformation: function(){
            let self = this;
            this.$http.get("/api/doctor/profile")
                .then(response =>
                {
                    self.doctorProfile = response.data;
                })
                .catch();
        },
        onSelect: function(value){
            this.selectedLanguageId = value;
        },
        editDoctorProfile: function(){
            let self = this;
            this.doctorProfile.languageId = this.doctorProfile.language.id
            this.$http.put("/api/doctor/edit", this.doctorProfile)
                .then(response =>
                {
                    self.response = response.data;
                })
                .catch();
        }
    },
    created: function () {
        this.getDoctorInformation();
        
    },
    watch: {
        response: function(val){
            setTimeout(() => {this.response.success = null}, 3000)
        },
        selectedLanguageId: function(val){
            this.doctorProfile.languageId = val;
            var selectedLanguageObj = this.languages.find(obj => {
                return obj.id === val;
            })
            this.doctorProfile.language = JSON.parse(JSON.stringify(selectedLanguageObj));
        }
    },
    computed: {
        languages: function(){
            var tempLanguages = this.$store.getters.systemLanguages;
            return tempLanguages;
        },
    }
}
</script>
<style lang="scss" scoped>
div{
    span.input-group-text {
        width: 200px !important;
    }
}
.rounded-circle {
            height : 1.5rem;
            width : 1.5rem;
        }
</style>

